"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class MailerController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/admin/config/mailer',
        };
    }
    list() {
        throw new Error("Can't list mailer");
    }
    count() {
        throw new Error("Can't count mailer");
    }
    create({}) {
        throw new Error("Can't create mailer!");
    }
    // eslint-disable-next-line
    edit(data) {
        return this.manager.put({ url: this.endpoints.get }, data);
    }
    delete() {
        throw new Error("Can't delete mailer!");
    }
    getConfig() {
        return this.manager.get({
            url: this.endpoints.get,
        });
    }
}
exports.default = MailerController;
